'use client';
import { useContext, createContext } from 'react';
import { EventBus } from '@s7/event-bus';

var queryEventBus = EventBus();
var defaultContext = [
    queryEventBus
];
var QueryInternalContext = /*#__PURE__*/ createContext(defaultContext);
function useQueryInternalContext() {
    return useContext(QueryInternalContext);
}

export { useQueryInternalContext };
